import type { CountryCode } from '@acceligentllc/shared/enums/countryCode';
import type { NotificationStatusEnum } from '@acceligentllc/shared/enums/notificationStatus';
import type { SubscriptionStatus } from '@acceligentllc/shared/enums/subscriptionStatus';

type NotificationModelBase = {
	fullName: string;
	email: Nullable<string>;
	officeNickname: string | undefined;
	phoneNumber: Nullable<string>;
	countryCode: Nullable<CountryCode>;
	emailInvalidatedAt: Nullable<Date>;
	phoneInvalidatedAt: Nullable<Date>;
	subscriptionStatus: SubscriptionStatus | undefined;
	smsStatus: NotificationStatusEnum | undefined;
	smsSentAt: Date | undefined;
	emailStatus: NotificationStatusEnum | undefined;
	emailSentAt: Date | undefined;
	emailErrorMessage: string | undefined;
	smsErrorMessage: string | undefined;
	notificationType: string | undefined;
};

interface EmployeeNotificationModel extends NotificationModelBase {
	employeeId: number;
}

interface TemporaryEmployeeNotificationModel extends NotificationModelBase {
	temporaryEmployeeId: number;
}

type NotificationModel = EmployeeNotificationModel | TemporaryEmployeeNotificationModel;

export function isEmployee(employee: NotificationModel): employee is EmployeeNotificationModel {
	return 'employeeId' in employee && !!employee.employeeId;
}

export function isTemporaryEmployee(temporaryEmployee: NotificationModel): temporaryEmployee is TemporaryEmployeeNotificationModel {
	return 'temporaryEmployeeId' in temporaryEmployee && !!temporaryEmployee.temporaryEmployeeId;
}
